import React, { Component } from 'react'
import { Grid, Cell } from 'react-mdl'
export default class Experience extends Component {
  render() {
    return (
        <Grid>

        <Cell>
          <p>{this.props.startyear} - {this.props.endyear}</p>
        </Cell>
        <Cell>
            <h4 style={{marginTop:'0px'}}>{this.props.jobName}</h4>
            <p>{this.props.jobDescription}</p>
        </Cell>
    </Grid>
    )
  }
}
